export var getDateAtZeroPoint = function (day) {
    var date = new Date(day);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
